<template>
  <div>
    <h2>For a basic example, consider the computed property <i>fullname</i>:</h2>
    <pre>
          <code>&lt;template&gt;
  &lt;h1&gt;{{ testString }}&lt;/h1&gt;
&lt;/template&gt;
&lt;script&gt;
export default {
  name: "Fullname", 
  data() {
    return {
      firstName: 'Paul',
      lastName: 'Walker',
    }
  },
  computed: {
    fullName() {
      return this.firstName + ' ' + this.lastName;
    }
  }
};
&lt;/script&gt;</code>
        </pre>

    <h2>Output</h2>
    <br />
    <p>
      The fullname property receives the this.firstName and this.lastName as a dependency from the
      data function, then returns a sentence containing the this.fullname and
      it’s made available directly to the template.
    </p>
    <v-card color="purple" dark>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{ fullName }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "Fullname",
  data() {
    return {
      firstName: 'Paul',
      lastName: 'Walker',
      testString: "{{fullName}}",
    };
  },
  computed: {
    fullName() {
      return this.firstName + ' ' + this.lastName;
    }
  },
};
</script>
